'use strict';

var settingsCtrl = function ($scope, railApi, $stateParams, $rootScope) {

    // List of IANA time zones (from Intl support)
    $scope.zones = [];
    if (typeof Intl.supportedValuesOf === 'function') {
        $scope.zones = [
                            { id: "America/St_Johns", name: "Newfoundland Time (St. John's)"},
                            // { id: "America/Halifax", name: "Atlantic Time (Halifax)"},
                            { id: "America/Moncton", name: "Atlantic Time (Moncton)"},
                            { id: "America/Toronto", name: "Eastern Time (Toronto)"},
                            { id: "America/Winnipeg", name: "Central Time (Winnipeg)"},
                            { id: "America/Regina", name: "Central Time (Regina - No DST)"},
                            { id: "America/Edmonton", name: "Mountain Time (Edmonton)",},
                            { id: "America/Vancouver", name: "Pacific Time (Vancouver)"},
                            { id: "America/Whitehorse", name: "Mountain Time (Whitehorse - No DST)"},
                        ];
    } else {
        // Minimal fallback list if Intl.supportedValuesOf is not available
        $scope.zones = ["UTC"];
    }

    // Function to get UTC offset
    $scope.getUTCOffset = function(timeZone) {
        var now = new Date();
        var formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            timeZoneName: 'shortOffset'
        });
        var parts = formatter.formatToParts(now);
        var offsetPart = parts.find(function(p) { return p.type === 'timeZoneName'; });
        var offsetValue = (offsetPart && offsetPart.value) ? offsetPart.value : '';
        return offsetValue.replace('GMT', 'UTC');
    }

    // Build array for ng-repeat
    $scope.timeZones = $scope.zones.map(function(tz) {
        return {
            name: tz.name,
            id: tz.id,
            offset: $scope.getUTCOffset(tz.id)
        };
    });
        
    $scope.colorPadding = function () {
        if($scope.ieDetector == true){
            return {"padding": ""};
        } else {
            return {"padding": "2px"};
        }
    }

    $scope.updateDefaultSort = function (defaultSort) {
        $rootScope.clientSettings.candidate_default_sort = defaultSort
    }


    ///////////////////////////////Division Company ID///////////////////////////////
    $scope.enableDivisionCompanyId = function(status){
      if( status == true ){
        railApi.put('organizations/1', {division_company_id: false}, 'organization').promise.then(function(){
          // window.location.reload();
        })
      }else{
        railApi.put('organizations/1', {division_company_id: true}, 'organization').promise.then(function(){
          // window.location.reload();
        })
      }
    }

    ///////////////////////////////

    $scope.saveCompanyId = function(alternate_company_name, company_id, job_division, alternate_email){
      railApi.post('company_ids/', {alternate_company_name: alternate_company_name, company_id_no: company_id, alternate_email: alternate_email, job_category_id: job_division}).promise.then(function(data){
        $scope.getCompanyIds()
      })
    }

    $scope.getCompanyIds = function(){
      $scope.divisions = []
      railApi.index('job_categories', {'category_type': 'division'}).promise.then(function(divisions){
        railApi.index('company_ids/').promise.then(function(data){
          $scope.company_ids = data
          $scope.company_ids.forEach(function(compds){
            divisions.splice(_.indexOf(divisions, _.findWhere(divisions, { id : compds.job_category.id})), 1)
          })
        })
  
        $scope.divisions = divisions
      });
      
    }
    var jobsCounterRequests = {}
    $scope.jobsCounter = function(division_id){
      try {
        if (!jobsCounterRequests[division_id]) {
          jobsCounterRequests[division_id] = railApi.post('jobs/search', {
            division_category: [{id: division_id}],
            limit: 10,
            offset: 0,
            status: 'active'
          })
        }
        return jobsCounterRequests[division_id].data.meta.total
      } catch (error) {

      }
    }
    $scope.warnRemoveCompanyId = function(id, index, company_id_no, jobs_used){

      if(jobs_used > 0){
      
        $scope.removeAltCompanyModal = $scope.modal.open({
            templateUrl: 'removeAltCompanyModal.ejs',
            scope: $scope,
            size: 'lg'
        });
        $scope.company_id = {id: id, index: index, company_id_no: company_id_no, job_count: jobs_used};
      }else{
        $scope.removeCompanyId(id, index, company_id_no)
      }
      
    }

    $scope.removeCompanyId = function(id, index, company_id_no){
      railApi.put('company_ids/' + id, {is_deleted: true, company_id_no: company_id_no}, 'company_id').promise.then(function(data){
        $scope.company_ids.splice(index, 1)
        $scope.getCompanyIds()
      })
    }
};



module.exports = settingsCtrl;
